import { Container, Row, Col, Text } from '@qonsoll/react-design'
import { FeatureList } from '../../../Feature/components'
import { useGetOfferFeatures } from '../../hooks'
import PropTypes from 'prop-types'
import { Spinner } from 'components'
import { useTranslations } from 'contexts/Translation'

export default function OfferFeatures(props) {
  const { offer } = props

  // [ADDITIONAL_HOOKS]
  const [features, loading] = useGetOfferFeatures(offer)
  const { t } = useTranslations()

  return (
    <Container>
      <Row noGutters>
        <Col>
          {loading ? (
            <Spinner flex={1} />
          ) : features?.length ? (
            <FeatureList {...props} hideAddCard features={features} />
          ) : (
            <Text type="secondary" variant="overline">
              {t('No features have been added yet')}
            </Text>
          )}
        </Col>
      </Row>
    </Container>
  )
}

OfferFeatures.propTypes = {
  offer: PropTypes.object.isRequired
}
